import { connect } from 'react-redux';

import DeleteOrDeactivateAccidentDialog from '../../components/DeleteOrDeactivateAccidentDialog';
import {
  showDeleteOrActivateAccidentDialogStatChanged,
  confirmDeleteDeactivateAccidentDispatc
} from '../../actions';

const mapStateToProps = (state, ownprops) => {
  return {
    accident: state.accident.deleteOrDeactivatingAccident.accident,
    open: state.accident.deleteOrDeactivatingAccident.open,
    status: state.accident.deleteOrDeactivatingAccident.status,
    isSaving: state.accident.deleteOrDeactivatingAccident.isSaving,
    errorMessage: state.accident.deleteOrDeactivatingAccident.errorMessage
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    showDialog: (open, accident, status) => {
      dispatch(
        showDeleteOrActivateAccidentDialogStatChanged(open, accident, status)
      );
    },
    onConfirmDeleteDeactivateAccident: (payload) => {
      dispatch(confirmDeleteDeactivateAccidentDispatc(payload));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteOrDeactivateAccidentDialog);
